var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / Clear") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Boost",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "INSURANCE-//-Payment-Copy-17",
    transform: "translate(-333.000000, -359.000000)",
    fill: "#CECECE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Clear",
    transform: "translate(333.000000, 359.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2,0.2 C15.6123905,0.2 20,4.58760945 20,10 C20,15.4123905 15.6123905,19.8 10.2,19.8 C4.78760945,19.8 0.4,15.4123905 0.4,10 C0.4,4.58760945 4.78760945,0.2 10.2,0.2 Z M13.4241898,6.2954062 L10.455,9.265 L7.48535569,6.2954062 C7.24511958,6.05517009 6.85652718,6.02558223 6.58192651,6.22135156 L6.49497475,6.29497475 L6.42070818,6.38220938 C6.22283675,6.6568692 6.24916144,7.03911093 6.4954062,7.28535569 L6.4954062,7.28535569 L9.465,10.255 L6.4954062,13.2241898 C6.24916144,13.4704345 6.22283675,13.8526762 6.42070818,14.1273361 L6.49497475,14.2145707 C6.76834175,14.4879377 7.21842668,14.4810683 7.48535569,14.2141392 L10.455,11.245 L13.4241898,14.2141392 C13.6644259,14.4543754 14.0530183,14.4839632 14.3276189,14.2881939 L14.4145707,14.2145707 L14.4888373,14.1273361 C14.6867087,13.8526762 14.660384,13.4704345 14.4141392,13.2241898 L14.4141392,13.2241898 L11.445,10.255 L14.4141392,7.28535569 C14.660384,7.03911093 14.6867087,6.6568692 14.4888373,6.38220938 L14.4145707,6.29497475 C14.1412037,6.02160774 13.6911188,6.02847719 13.4241898,6.2954062 Z",
    id: "clear"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseGrey);
export default __webpack_public_path__ + "static/media/close-grey.b9937736.svg";
export { ForwardRef as ReactComponent };